import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: '256-bit SSL encryption protects your financial data'
    },
    {
      icon: 'Lock',
      title: 'SOC 2 Compliant',
      description: 'Certified for security, availability, and confidentiality'
    },
    {
      icon: 'CheckCircle',
      title: 'GAAP Compliant',
      description: 'Follows Generally Accepted Accounting Principles'
    },
    {
      icon: 'Users',
      title: 'Trusted by 50,000+',
      description: 'Businesses worldwide trust our platform'
    }
  ];

  const certifications = [
    {
      name: 'SOC 2 Type II',
      icon: 'Award',
      color: 'text-primary'
    },
    {
      name: 'ISO 27001',
      icon: 'Shield',
      color: 'text-success'
    },
    {
      name: 'PCI DSS',
      icon: 'CreditCard',
      color: 'text-accent'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground text-center">
          Enterprise-Grade Security
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {trustFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3 p-4 bg-muted/30 rounded-lg">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Certifications */}
      <div className="space-y-4">
        <h4 className="font-medium text-foreground text-center">Security Certifications</h4>
        <div className="flex justify-center space-x-6">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex flex-col items-center space-y-2">
              <div className="w-12 h-12 bg-surface border border-border rounded-lg flex items-center justify-center">
                <Icon name={cert?.icon} size={20} className={cert?.color} />
              </div>
              <span className="text-xs text-muted-foreground text-center">{cert?.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Data Protection Notice */}
      <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium">Your Data is Protected</p>
            <p className="text-xs text-muted-foreground mt-1">
              We use advanced encryption and never share your financial information with third parties. 
              Your data remains completely private and secure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;